import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import SignalListTable, {
  signalListTableColumns
} from 'components/tables/SignalListTable';
import { defaultBreadcrumbItems } from 'data/commonData';
import { signals } from 'data/settings/signals';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { Link } from 'react-router-dom';

const List = () => {
  const table = useAdvanceTable({
    data: signals,
    columns: signalListTableColumns,
    pageSize: 8,
    pagination: true,
    sortable: true
  });

  return (
    <div>
      <PageBreadcrumb items={defaultBreadcrumbItems} />
      <AdvanceTableProvider {...table}>
        <div className="d-flex flex-wrap mb-4 gap-3 gap-sm-6 align-items-center">
          <h2 className="mb-0">
            <span className="me-3">Sinalizações</span>{' '}
            <span className="fw-normal text-700">({signals.length})</span>
          </h2>
          <Link className="btn btn-primary px-5" to="/settings/signals/add-new">
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            Adicionar Nova Sinalização
          </Link>
        </div>
        <SignalListTable />
      </AdvanceTableProvider>
    </div>
  );
};

export default List;
